var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.menuContent, function (list, index) {
      return _c(
        "div",
        { key: `menu-${index}` },
        [
          _vm._l(list, function (item, index) {
            return [
              item.linkActive
                ? [
                    item.columns && item.columns.length
                      ? [
                          _c(
                            "transition",
                            {
                              key: `list-${index}`,
                              attrs: { name: "slide-fade" },
                            },
                            [
                              _c(
                                "b-nav-item-dropdown",
                                {
                                  key: index,
                                  class: { "mega-menu": item.linkMegaMenu },
                                  attrs: {
                                    text: item.linkText,
                                    title: item.linkTitle,
                                  },
                                },
                                _vm._l(
                                  item.columns,
                                  function (subItem, subIndex) {
                                    return _c(
                                      "li",
                                      {
                                        key: `item-${subIndex}`,
                                        staticClass: "nav-item floated",
                                      },
                                      [
                                        subItem.linkActive
                                          ? [
                                              _c(
                                                "div",
                                                { key: subIndex },
                                                [
                                                  subItem.columns
                                                    ? [
                                                        _c("h3", [
                                                          _vm._v(
                                                            _vm._s(
                                                              subItem.linkText
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "ul",
                                                          _vm._l(
                                                            subItem.columns,
                                                            function (
                                                              subSubItem,
                                                              subSubIndex
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  key: `subitem-${subSubIndex}`,
                                                                  staticClass:
                                                                    "nav-item",
                                                                },
                                                                [
                                                                  subSubItem.linkActive
                                                                    ? [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            key: subSubIndex,
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  subSubItem.linkText
                                                                                ) +
                                                                                "\n                            "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    : _vm._e(),
                                                                ],
                                                                2
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "ul",
                                                          [
                                                            _c(
                                                              "generic-link",
                                                              {
                                                                class: `single-link btn-${subItem.linkCallToAction}`,
                                                                attrs: {
                                                                  href: subItem.linkUrl,
                                                                  target:
                                                                    subItem.linkTarget,
                                                                  title:
                                                                    subItem.linkTitle,
                                                                  tag: "b-nav-item",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      subItem.linkText
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                ],
                                                2
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c(
                            "generic-link",
                            {
                              key: `menu-${index}`,
                              class: `btn-${item.linkCallToAction}`,
                              attrs: {
                                href: item.linkUrl,
                                target: item.linkTarget,
                                title: item.linkTitle,
                                tag: "b-nav-item",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.linkText) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                  ]
                : _vm._e(),
            ]
          }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }